var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJourneyPagePointsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_14520_6642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6066 0.962482L17.2359 6.09681C17.4969 6.60641 18.0013 6.95944 18.5849 7.04121L24.464 7.86458C25.9335 8.07035 26.5204 9.81081 25.457 10.8098L21.2028 14.8062C20.7805 15.2029 20.5879 15.7744 20.6876 16.3346L21.6918 21.9776C21.9429 23.3881 20.4066 24.4638 19.0922 23.7978L13.8337 21.1334C13.3117 20.8688 12.6883 20.8688 12.1663 21.1334L6.90779 23.7978C5.59341 24.4638 4.05715 23.3881 4.30818 21.9776L5.31244 16.3346C5.4121 15.7744 5.21953 15.2029 4.79718 14.8062L0.54297 10.8098C-0.520383 9.81081 0.0665222 8.07035 1.53596 7.86458L7.41515 7.04121C7.99867 6.95944 8.50314 6.60641 8.76414 6.09681L11.3934 0.962482C12.0505 -0.320827 13.9495 -0.320827 14.6066 0.962482Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_14520_6642",
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.552941 0 0 0 0 0.027451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14520_6642"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyPagePointsStar);
export default __webpack_public_path__ + "static/media/journey_page_points_star.4b3b5e60f63f9cfec693265e8bb72136.svg";
export { ForwardRef as ReactComponent };